/**
 * How an app's group restriction is displayed.
 *
 * This is the most dangerous rendering in the application, for a non-obvious reason: the MOST
 * permissive setting - any authenticated user in the tenant may sign in - is represented by an EMPTY
 * array. A table that renders `required_group_ids.join(', ')` therefore shows a blank cell for the
 * one configuration that most deserves attention, and a blank cell reads as "not configured yet".
 *
 * So there is no code path here that produces empty output. The CLI makes the same call, printing
 * "none - ANY authenticated Entra user may sign in" rather than an empty list.
 */
export function AccessBadge({ groupIds }: { groupIds: string[] }) {
  if (groupIds.length === 0) {
    return (
      <span className="badge badge-warn" title="Any authenticated user in the Entra tenant">
        ⚠ Any signed-in user
      </span>
    );
  }

  return (
    <span className="badge badge-ok">
      {groupIds.length} {groupIds.length === 1 ? 'group' : 'groups'}
    </span>
  );
}

/** The full-width version, for the detail and edit views. */
export function UnrestrictedCallout() {
  return (
    <div className="callout callout-warn" role="status">
      <strong>This app has no group restriction.</strong> Any authenticated user in the Entra tenant
      can sign in to it.
    </div>
  );
}
